export const POPULAR_ADDRESSES = [
  'AFS1xYgD9YaFGd2iMUy5PbDbst5pFR2oTd5af9hkTH9u',
  '9mXZsKuQGeHeVCcxQntr2LdJfWB9sBnXgRXrFj7Bfsg5',
  'F7KSBM7SVVYUczJTCLpLJFPDEBrmrfi9ZiGru1BzAuwi',
  'DzcECUzDbmAq97E1tpfAWR5GHxfksDLpH3E9wKpTA9eH',
  'ECMvT4GQ59aWQVidtzarfvSr7vaZZUnvi1SvaurmtLRD',
  'AnBVRfcUFzL1RhzvMtU127HjdgMSj5MNqNx2WKfYAvNp',
  '7Z5VhcNSpMpaTVqRg8QTkySw6syfcTehTx8CqRPvf9bg',
];

export const RECENT_COPIES = [
  '7YndBV5gp3VvAiBbSfv8M7CoyMhFsiKeGYWkwee49fTg',
  '6hcX7fVMzeRpW3d7XhFsxYw2CuePfgSMmouZxSiNLj1U',
  '9HCTuTPEiQvkUtLmTZvK6uch4E3pDynwJTbNw6jLhp9z',
  'FZVdsFTRTWwZEy6XC5GCtHNWdcAwiQtAeJ2NSpH6cQNz',
  '4dAroqRjhybdrkAS1BDHSm1137vc1TNzrhWPPd5i9vbK',
  '52dq6ajenMwfVz5FYuPKKRzzjkW83Aa85X5xJgFHX7U1',
  '9qkw1M8VmFAqZvvsyXromDx4voFfHrsE1Gzmws9PY9At',
];
export const AI_PICKS = [
  've94tFcRnLnwMGf7e5mUXMyAkzzcS4qkzSKZGsQV4kk',
  'HXkaN7TAQYXsybY1UHLrn18cVa9jgM3mbReasbAoSjTv',
  '6Ghj4rQoEFpTuHbVEf1uVPJXVqLsujaV3rGt7Nigioaz',
  '4t9bWuZsXXKGMgmd96nFD4KWxyPNTsPm4q9jEMH4jD2i',
  '45yBcpnzFTqLYQJtjxsa1DdZkgrTYponCg6yLQ6LQPu6',
  '72e6QM7gn9MH5u1YpgQbduexm4WAon1cnsSXPqKnLQec',
  'DfMxre4cKmvogbLrPigxmibVTTQDuzjdXojWzjCXXhzj',
]; 